var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory42(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 201,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -449)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.377 524.799C249.405 520.414 250 515.848 250 511.137 250 477.925 223.21 451 190.165 451 170.099 451 152.414 460.947 141.543 476.167 130.69 460.965 112.986 451 92.9209 451 70.548 451 51.2579 463.484 40.9999 481.766 73.8832 541.469 124.831 589.702 186.451 619 215.963 594.521 242.897 559.08 248.377 524.799Z",
    fill: "#FFAC33",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 512.691C220 479.725 193.2 453 160.141 453 140.068 453 122.375 462.874 111.5 477.981 100.643 462.874 82.9322 453 62.859 453 29.8005 453 3.0001 479.725 3.0001 512.691 3.0001 517.367 3.59526 521.881 4.60523 526.251 12.9195 577.741 70.3256 632.073 111.482 647 152.638 632.091 210.045 577.759 218.359 526.269 219.405 521.881 220 517.349 220 512.691Z",
    fill: "#DD2E44",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory42);
export default __webpack_public_path__ + "static/media/accessory4-2.a7846620b90ee04b0265af547b557309.svg";
export { ForwardRef as ReactComponent };